// Copyright (c) 2020 Comsearch, Inc., All rights reserved

import getNewModulationErrorMessages from './getNewModulationErrorMessages'

// when a new modulation fails validation, we cannot use radioModulationId to map it to the corresponding modulation in the UI.
// Instead we figure out which new modulations are using the same modulation scheme that threw the error.

// we create a new errors object which is a deep clone of the one radioDetails holds.
// This way we can insert a special message with getNewModulationErrorMessages() that wont be seen
// on the radioDetails form.

const getNewModulationErrorsByModulationSchemeDescription = (errorsList, modulationSchemeDescription) => dispatch => {
  const modulationErrorFromRadioDetails = (
    errorsList.find(d => d.header.includes(modulationSchemeDescription)) ||
    null
  )

  if (modulationErrorFromRadioDetails === null) {
    return null
  }

  const messages = dispatch(getNewModulationErrorMessages(modulationErrorFromRadioDetails, modulationSchemeDescription))

  return {
    ...modulationErrorFromRadioDetails,
    messages,
  }
}

export default getNewModulationErrorsByModulationSchemeDescription
